import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitDashboardConfigTask extends Task {
    constructor(assetLibrary, dashboardConfig) {
        super();

        this.execute = (callback, progressCallback) => {
            const dashboardJson = assetLibrary.getAsset("dashboard-config");
            dashboardConfig.setPropertiesFromObject(dashboardJson);
            callback(this);
        }
    }
}